export default "__VITE_ASSET__ca21d806__"